import type { FC } from 'react'
import styled from '@emotion/styled'

import ColumnTrack from '@segment/matcha/components/ColumnTrack'

import { BusinessIcon, LearningIcon } from '@segment/matcha/components/Icons/Brandbook'

import IconWrapper from '@segment/matcha/components/IconWrapper'

import { ChevronRightIcon } from '@segment/matcha/components/Icons/Common'

import CardBase, * as Card from '@segment/matcha/recipes/Card'

import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'
import SectionBase, * as Section from '@segment/matcha/recipes/Section'

const copy = {
  heading: `Additional resources`,
}

const cards = [
  {
    icon: <LearningIcon />,
    title: `Segment University`,
    description: `Self-paced online courses from fundamentals to advanced features.`,
    url: `https://university.segment.com/`,
  },
  {
    icon: <BusinessIcon />,
    title: `Assess your Data Maturity Score`,
    description: `Use Segment’s Customer Data Maturity Model to evaluate your data strategy and receive actionable recommendations on how to improve.`,
    url: `https://segment.com/customer-data-maturity/`,
  },
  {
    icon: <LearningIcon />,
    title: `Achieving Good Data at Scale`,
    description: `Learn about best practices Segment’s largest customers utilize to ensure good data across teams.`,
    url: `https://segment.com/blog/what-does-it-take-to-achieve-good-data-at-enterprise-scale/`,
  },
]

const AdditionalResources: FC = () => (
  <StyledSection variant="centered">
    <Section.Copy>
      <CopyTextBase centered={true}>
        <CopyText.Heading variant="h2" tag="h2">
          {copy.heading}
        </CopyText.Heading>
      </CopyTextBase>
    </Section.Copy>
    <Section.Contents>
      <ColumnTrack columns={1} overrides={{ md: 3 }}>
        {cards.map((card, index) => (
          <CardBase key={index} href={card.url}>
            <Card.Body>
              <Card.Accessories>
                <Card.AccessoriesRow>
                  <IconWrapper variant="transparent">{card.icon}</IconWrapper>
                </Card.AccessoriesRow>
              </Card.Accessories>
              <Card.Copy>
                <Card.Headline tag="h3">{card.title}</Card.Headline>
                <Card.Description variant="pMedium">{card.description}</Card.Description>
              </Card.Copy>
              <Card.Action alignment="right">
                <ChevronRightIcon />
              </Card.Action>
            </Card.Body>
          </CardBase>
        ))}
      </ColumnTrack>
    </Section.Contents>
  </StyledSection>
)

const StyledSection = styled(SectionBase)`
  ${Section.Wrapper} {
    row-gap: 40px;
  }

  ${Section.Contents} {
    max-width: 1120px;
  }
`

export default AdditionalResources
